import React from 'react';
import { Container, Typography, Paper, makeStyles, Grid, Divider } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(8),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        background: "lightgray",
        minHeight: '100vh',
        maxWidth: "none",
        overflow: 'auto',
    },
    paperContent: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(1),
        position: 'sticky',
        top: 0,
        height: '30vh',

    },
    paper: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(1),
        overflow: 'auto',
        flex: 1,
        overflowY: 'auto', // Scrollen nur im Hauptinhalt
        position: 'sticky',
        top: 0,
        height: '90vh',
    },

    section: {
        marginBottom: theme.spacing(4),
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 'bold',
    },
    text: {
        marginBottom: theme.spacing(1),
    },
    list: {
        marginLeft: theme.spacing(2),
    },
    sidebar: {
        position: 'sticky',
        top: theme.spacing(8),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[1],
    },
    sidebarLink: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(1),
        display: 'block',
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

export const Documentation = () => {
    const classes = useStyles();

    return (
        <Container className={classes.container}>
            <Grid container spacing={2}>
                {/* Inhaltsangabe auf der linken Seite */}
                <Grid item xs={12} md={2}>
                    <Paper className={classes.paperContent}>

                        <Typography variant="h6" className={classes.title}>
                            Inhaltsangabe
                        </Typography>
                        <a href="#einleitung" className={classes.sidebarLink}>Einleitung</a>
                        <a href="#anmeldung" className={classes.sidebarLink}>Anmeldung</a>
                        <a href="#navigation" className={classes.sidebarLink}>Navigation</a>
                        <a href="#hauptansicht" className={classes.sidebarLink}> - Hauptansicht (Home)</a>
                        <a href="#begriffe-erstellen" className={classes.sidebarLink}> - Begriffe erstellen (Create)</a>
                        <a href="#links-analysieren" className={classes.sidebarLink}> - Links analysieren (Link)</a>
                        <a href="#begriffe-importieren" className={classes.sidebarLink}> - Begriffe importieren (Import)</a>
                        <a href="#verwaltung" className={classes.sidebarLink}> - Verwaltung (Admin)</a>

                    </Paper>
                </Grid>

                {/* Hauptinhalt */}
                <Grid item xs={12} md={10}>
                    <Paper className={classes.paper}>
                        <Typography variant="h4" className={classes.title}>
                            Benutzerhandbuch für die Anwendung (DE)
                        </Typography>

                        <div id="einleitung" className={classes.section}>
                            <Typography variant="h5" className={classes.title}>
                                Einleitung
                            </Typography>
                            <Typography className={classes.text}>
                                Willkommen zu LIMANTIC! Dieses Handbuch bietet eine Anleitung zur Nutzung der verschiedenen Funktionen der Anwendung. Die Anwendung dient zur Verwaltung von Begriffen, Links und deren Beziehungen. Sie bietet eine benutzerfreundliche Oberfläche für die Navigation, Bearbeitung und Analyse von Daten.
                            </Typography>
                        </div>

                        <div id="anmeldung" className={classes.section}>
                            <Typography variant="h5" className={classes.title}>
                                Anmeldung
                            </Typography>
                            <Typography className={classes.text}>
                                Melden Sie sich mit Ihren Zugangsdaten an, um Zugriff auf die Anwendung zu erhalten.
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Schritte:</strong>
                            </Typography>
                            <ol className={classes.list}>
                                <li>Öffnen Sie die Anwendung im Browser.</li>
                                <li>Geben Sie Ihren Benutzernamen und Ihr Passwort auf der Login-Seite ein.</li>
                                <li>Klicken Sie auf <strong>Login</strong>.</li>
                                <li>Nach erfolgreicher Anmeldung werden Sie zur Hauptseite weitergeleitet.</li>
                            </ol>
                        </div>

                        <div id="navigation" className={classes.section}>
                            <Typography variant="h5" className={classes.title}>
                                Navigation
                            </Typography>
                            <Typography className={classes.text}>
                                Die Navigation erfolgt über die linke Seitenleiste und die obere Navigationsleiste.
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Seitenleiste:</strong>
                            </Typography>
                            <ul className={classes.list}>
                                <li><strong>Home:</strong> Zurück zur Hauptansicht mit Begriffstabelle, Visualisierung und Detailansicht.</li>
                                <li><strong>Create:</strong> Erstellen Sie neue Begriffe.</li>
                                <li><strong>Link:</strong> Analysieren Sie Links zwischen Begriffen.</li>
                                <li><strong>Import:</strong> Importieren Sie Begriffe aus einer Excel-Datei.</li>
                                <li><strong>Admin:</strong> Zugriff auf Verwaltungsfunktionen (nur für Admin-Benutzer).</li>
                            </ul>
                            <Typography className={classes.text}>
                                <strong>Navigationsleiste:</strong>
                            </Typography>
                            <ul className={classes.list}>
                                <li><strong>Logout:</strong> Melden Sie sich von der Anwendung ab.</li>
                            </ul>
                        </div>
                      
                        <div id="hauptansicht" className={classes.section}>
                            <Divider className={classes.divider} />
                            <Typography variant="h5" className={classes.title}>
                                Hauptansicht (Home)
                            </Typography>
                            <Typography className={classes.text}>
                                Die Hauptansicht besteht aus drei Bereichen:
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>1. Begriffstabelle:</strong>
                            </Typography>
                            <ul className={classes.list}>
                                <li>Zeigt eine Liste aller Begriffe an.</li>
                                <li>Klicken Sie auf einen Begriff, um Details anzuzeigen.</li>
                                <li>Funktionen:
                                    <ul>
                                        <li><strong>Filter:</strong> Filtern Sie Begriffe nach Typ, Domain oder anderen Kriterien.</li>
                                        <li><strong>Sortieren:</strong> Sortieren Sie Begriffe alphabetisch oder nach anderen Attributen.</li>
                                    </ul>
                                </li>
                            </ul>
                            <Typography className={classes.text}>
                                <strong>2. Visualisierung:</strong>
                            </Typography>
                            <ul className={classes.list}>
                                <li>Zeigt Beziehungen zwischen Begriffen und Links als Diagramm an.</li>
                                <li>Wählen Sie zwischen zwei Visualisierungsmodi:
                                    <ul>
                                        <li><strong>Flow-Chart:</strong> Zeigt die Beziehungen in einem Flussdiagramm.</li>
                                        <li><strong>Force-Graph:</strong> Zeigt die Beziehungen in einem interaktiven Netzwerkdiagramm.</li>
                                    </ul>
                                </li>
                            </ul>
                            <Typography className={classes.text}>
                                <strong>3. Detailansicht:</strong>
                            </Typography>
                            <ul className={classes.list}>
                                <li>Zeigt detaillierte Informationen zu einem ausgewählten Begriff.</li>
                                <li>Funktionen:
                                    <ul>
                                        <li><strong>Bearbeiten:</strong> Ändern Sie die Eigenschaften eines Begriffs.</li>
                                        <li><strong>Verknüpfungen anzeigen:</strong> Zeigt alle Links, die mit dem Begriff verbunden sind.</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                        <div id="begriffe-erstellen" className={classes.section}>
                            <Typography variant="h5" className={classes.title}>
                                Begriffe erstellen (Create)
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Zweck:</strong> Fügen Sie neue Begriffe zur Datenbank hinzu.
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Schritte:</strong>
                            </Typography>
                            <ol className={classes.list}>
                                <li>Navigieren Sie zur <strong>Create</strong>-Seite.</li>
                                <li>Füllen Sie die Felder (Name, Beschreibung, Typ, Domain) aus.</li>
                                <li>Klicken Sie auf <strong>Speichern</strong>, um den Begriff hinzuzufügen.</li>
                            </ol>
                            <Typography className={classes.text}>
                                <strong>Hinweis:</strong> Stellen Sie sicher, dass der Begriff einen eindeutigen Namen hat.
                            </Typography>
                        </div>



                        <div id="links-analysieren" className={classes.section}>
                            <Typography variant="h5" className={classes.title}>
                                Links analysieren (Link)
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Zweck:</strong> Analysieren Sie die Beziehungen zwischen Begriffen.
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Schritte:</strong>
                            </Typography>
                            <ol className={classes.list}>
                                <li>Navigieren Sie zur <strong>Link</strong>-Seite.</li>
                                <li>Sehen Sie sich die Liste der Links und deren Details an.</li>
                                <li>Nutzen Sie die Filteroptionen, um spezifische Links zu finden.</li>
                            </ol>
                            <Typography className={classes.text}>
                                <strong>Funktionen:</strong>
                            </Typography>
                            <ul className={classes.list}>
                                <li><strong>Link-Typen anzeigen:</strong> Zeigt die verschiedenen Typen von Links.</li>
                                <li><strong>Verknüpfungen bearbeiten:</strong> Ändern Sie die Eigenschaften eines Links.</li>
                            </ul>
                        </div>

                        <div id="begriffe-importieren" className={classes.section}>
                            <Typography variant="h5" className={classes.title}>
                                Begriffe importieren (Import)
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Zweck:</strong> Importieren Sie Begriffe aus einer Excel-Datei.
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Schritte:</strong>
                            </Typography>
                            <ol className={classes.list}>
                                <li>Navigieren Sie zur <strong>Import</strong>-Seite.</li>
                                <li>Laden Sie eine Excel-Datei hoch, die die Begriffe enthält.</li>
                                <li>Die Begriffe werden automatisch in die Datenbank eingefügt.</li>
                            </ol>
                            <Typography className={classes.text}>
                                <strong>Hinweis:</strong> Die Excel-Datei muss ein bestimmtes Format haben (z. B. Spalten für Name, Typ, Domain).
                            </Typography>
                        </div>


                        <div id="verwaltung" className={classes.section}>
                            <Typography variant="h5" className={classes.title}>
                                Verwaltung (Admin)
                            </Typography>
                            <Typography className={classes.text}>
                                Der Admin-Bereich bietet Funktionen zur Verwaltung von Benutzern, Einstellungen und Datenbankaktionen. Dieser Bereich ist nur für Benutzer mit Administratorrechten zugänglich.
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Zweck:</strong> Verwalten Sie Benutzer und Einstellungen.
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Funktionen:</strong>
                            </Typography>
                            <ul className={classes.list}>
                                <li>Benutzer hinzufügen, bearbeiten oder löschen.</li>
                                <li>Einstellungen für Begriffe Typen, Link Typen und Domains.</li>
                            </ul>


                            <Typography variant="h6" className={classes.title}>
                                Benutzerverwaltung
                            </Typography>
                            <Typography className={classes.text}>
                                Im Admin-Bereich können neue Benutzer erstellt, bestehende Benutzer angezeigt, bearbeitet oder gelöscht werden.
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Funktionen:</strong>
                            </Typography>
                            <ul className={classes.list}>
                                <li><strong>Benutzer erstellen:</strong> Fügen Sie neue Benutzer zur Gruppe hinzu, indem Sie Name, E-Mail, Passwort und Berechtigung angeben.</li>
                                <li><strong>Benutzer anzeigen:</strong> Zeigt eine Liste aller Benutzer in der aktuellen Gruppe an.</li>
                                <li><strong>Benutzer bearbeiten:</strong> Ändern Sie die Details eines Benutzers, wie z. B. Name oder Berechtigung.</li>
                                <li><strong>Benutzer löschen:</strong> Entfernen Sie einen Benutzer aus der Gruppe.</li>
                            </ul>

                            <Typography variant="h6" className={classes.title}>
                                Parameterverwaltung
                            </Typography>
                            <Typography className={classes.text}>
                                Verwalten Sie Parameter wie Domains, Begriffstypen und Linktypen. Diese Parameter werden in der gesamten Anwendung verwendet.
                            </Typography>
                            <Typography className={classes.text}>
                                <strong>Funktionen:</strong>
                            </Typography>
                            <ul className={classes.list}>
                                <li><strong>Parameter anzeigen:</strong> Zeigt die aktuellen Parameter in einer Tabelle an.</li>
                                <li><strong>Parameter bearbeiten:</strong> Ändern Sie die Werte eines Parameters direkt in der Tabelle.</li>
                                <li><strong>Parameter löschen:</strong> Entfernen Sie einen Parameter aus der Liste.</li>
                            </ul>

                        </div>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
};